import anime from 'animejs'
import _ from 'lodash'

export const easings = {
  LINEAR: 'linear',
  EASE_IN_QUAD: 'easeInQuad',
  EASE_IN_CUBIC: 'easeInCubic',
  EASE_IN_QUART: 'easeInQuart',
  EASE_IN_QUINT: 'easeInQuint',
  EASE_IN_SINE: 'easeInSine',
  EASE_IN_EXPO: 'easeInExpo',
  EASE_IN_CIRC: 'easeInCirc',
  EASE_IN_BACK: 'easeInBack',
  EASE_OUT_QUAD: 'easeOutQuad',
  EASE_OUT_CUBIC: 'easeOutCubic',
  EASE_OUT_QUART: 'easeOutQuart',
  EASE_OUT_QUINT: 'easeOutQuint',
  EASE_OUT_SINE: 'easeOutSine',
  EASE_OUT_EXPO: 'easeOutExpo',
  EASE_OUT_CIRC: 'easeOutCirc',
  EASE_OUT_BACK: 'easeOutBack',
  EASE_IN_OUT_QUAD: 'easeInOutQuad',
  EASE_IN_OUT_CUBIC: 'easeInOutCubic',
  EASE_IN_OUT_QUART: 'easeInOutQuart',
  EASE_IN_OUT_QUINT: 'easeInOutQuint',
  EASE_IN_OUT_SINE: 'easeInOutSine',
  EASE_IN_OUT_EXPO: 'easeInOutExpo',
  EASE_IN_OUT_CIRC: 'easeInOutCirc',
  EASE_IN_OUT_BACK: 'easeInOutBack',
}

export const TARGET_ROOT = el => el
export const TARGET_CHILDREN = el => el.children

const animation = config => el => {
  const { targets } = config
  return anime({
    targets: _.isFunction(targets) ? targets(el) : el,
    ..._.omit(config, 'targets'),
  })
}

// *********************************************************
// Basic animations
// *********************************************************

const fade = {
  easing: easings.LINEAR,
}

const scale = {
  easing: easings.EASE_IN_OUT_QUAD,
  duration: 300,
}

export const custom = config => animation({ ...config })

export const fadeIn = config =>
  animation({ ...fade, opacity: [0, 1], ...config })

export const fadeOut = config => animation({ ...fade, opacity: 0, ...config })

export const slideInUp = config =>
  animation({ opacity: [0, 1], translateY: [20, 0], ...config })

export const slideOutDown = config =>
  animation({ opacity: 0, translateY: 20, ...config })

export const scaleInY = config =>
  animation({ ...scale, scaleY: [0, 1], ...config })

export const scaleOutY = config => animation({ ...scale, scaleY: 0, ...config })

export const scaleIn = config =>
  animation({ ...scale, scale: [0, 1], ...config })

export const scaleOut = config => animation({ ...scale, scale: 0, ...config })

export const stagger = amount => (node, i, count) => i * amount
export const staggerReverse = amount => (node, i, count) => (count - i) * amount

// *********************************************************
// Component animations
// *********************************************************

const timelineOptions = {
  targets: TARGET_CHILDREN,
  easing: easings.EASE_IN_OUT_QUAD,
  duration: 500,
}

export const timelineShow = custom({
  ...timelineOptions,
  translateY: ['100%', 0],
  delay: 1200,
})

export const timelineHide = custom({
  ...timelineOptions,
  translateY: '100%',
  delay: 100,
})

export const legendShow = custom({
  ...timelineOptions,
  translateX: ['200%', 0],
  delay: 2000,
  // loop: true,
  // direction: 'alternate',
})

export const legendHide = custom({
  ...timelineOptions,
  translateX: '200%',
  delay: 100,
})

// *********************************************************
// Utilities
// *********************************************************

const precision = 0

const getPoints = el =>
  _.map(el.querySelectorAll('polygon'), x =>
    _.flatten(
      _.map(x.points, ({ x, y }) => [
        _.round(x, precision),
        _.round(y, precision),
      ])
    ).join(' ')
  )

export const transformPolygons = el => {
  const points = getPoints(el)
  const timeline = anime.timeline({
    loop: true,
    direction: 'alternate',
    easing: easings.EASE_IN_OUT_QUAD,
    duration: 4000,
  })

  timeline
    .add({
      targets: el.querySelectorAll('polygon')[0],
      points: [{ value: points[1] }, { value: points[2] }],
    })
    .add({
      targets: el.querySelectorAll('polygon')[1],
      points: [{ value: points[2] }, { value: points[0] }],
      offset: '-=3000',
    })
    .add({
      targets: el.querySelectorAll('polygon')[2],
      points: [{ value: points[0] }, { value: points[1] }],
      offset: '-=3000',
    })

  return timeline
}
